import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyProfileComponent } from './my-profile.component';
import { RouterModule, Routes } from '@angular/router';
import { MainPanelModule } from '../main-panel/main-panel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const routes: Routes = [
  { path: '', component: MyProfileComponent }
]

@NgModule({
  imports: [
    CommonModule,
    MainPanelModule,
    FormsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [MyProfileComponent]
})
export class MyProfileModule { }
